//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'DiscordPreFlightCheck',

    methods: {
        trackView() {
            this.$gtag.event('discord-preflight-yes')
            this.$vuedals.close(this)
        },

        close() {
            this.$gtag.event('discord-preflight-no')
            this.$vuedals.close(this)
        },
    },
}
